import React, { SVGProps } from 'react'
const SvgCardLoD = (props: SVGProps<SVGSVGElement>): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    aria-hidden="true"
    {...props}
  >
    <g fill="#FFF" fillRule="nonzero">
      <path d="M18.946 6.25H6.054c-.995 0-1.804.809-1.804 1.804v8.892c0 .995.809 1.804 1.804 1.804h12.892c.995 0 1.804-.809 1.804-1.804V8.054c0-.995-.809-1.804-1.804-1.804Zm0 1.5c.167 0 .304.137.304.304v8.892a.306.306 0 0 1-.304.304H6.054a.306.306 0 0 1-.304-.304V8.054c0-.167.137-.304.304-.304h12.892Z" />
      <path d="M18.946 6.25H6.054c-.995 0-1.804.809-1.804 1.804v3.196h16.5V8.054c0-.995-.809-1.804-1.804-1.804ZM5.75 9.75V8.054c0-.167.137-.304.304-.304h12.892c.167 0 .304.137.304.304V9.75H5.75ZM12.5 9.75v1.5-1.5ZM14.5 15.75h2.75a.75.75 0 1 0 0-1.5H14.5a.75.75 0 1 0 0 1.5Z" />
    </g>
  </svg>
)
export default SvgCardLoD
